import React from 'react'

//styles
import "./FaqItem.css"

import { Faq as FaqModel } from '../../Models/Faq';
import { motion, MotionProps } from 'framer-motion';

interface Props {
    faq:FaqModel
    delay:number
}

const FaqItem = ({faq, delay}:Props) => {

  const getFadeUpAnimation = (index = 0): MotionProps => ({
    initial: { opacity: 0, x: -50 },
    whileInView: { opacity: 1, x: 0 },
    viewport: { once: true, margin: "0px" },
    transition: {
        duration: 0.5,
        ease: "easeOut",
        delay: index * 0.3,
    },
    });

  return (
    <motion.div className='faq-item' {...getFadeUpAnimation(delay)}>
      <div className='faq-item-header'>
        {faq.icon}
        <span>{faq.question}</span>
      </div>
    
        <div className='faq-item-answ'>
            <span>{faq.answer}</span>
        </div>

    </motion.div>
  )
}

export default FaqItem